/* eslint-disable @typescript-eslint/no-explicit-any */
import type { ActiveModelState, ModalAction, ModalHeader } from '@qse/constants'
import { ModelControlEnum } from '@qse/constants'
import { create } from 'zustand'

export const useActiveModelStore = create<ActiveModelState>(set => ({
  toggleModel: false,
  modelActive: ModelControlEnum.CONFIRMATION,
  scrollBehavior: 'outside',
  modelContent: '',
  classNames: { className: 'grid', classNameContent: '' },
  width: '',
  data: null,
  // Modal customization
  modalHeader: {
    title: 'Confirmation',
    subtitle: '',
    showCloseButton: true,
    className: '',
  },
  modalActions: [],
  // Track previous modal state for nested operations
  previousModalState: null,

  setToggleModel: (toggle: boolean) => set(() => ({ toggleModel: toggle })),
  setClassNames: (classNames: { className: string; classNameContent: string }) =>
    set(() => ({ classNames })),
  setModelActive: (drawerName: ModelControlEnum, additionalData?: any) =>
    set(state => ({
      modelActive: drawerName,
      ...(additionalData && { data: additionalData }),
      // Store current modal state as previous if we're switching modals
      ...(state.modelActive !== drawerName && {
        previousModalState: { modelActive: state.modelActive, data: state.data },
      }),
    })),
  setModelContent: (content: string) => set(() => ({ modelContent: content })),
  setWidth: (width: string) => set(() => ({ width })),
  setData: (data: any) => set(() => ({ data })),
  setModalHeader: (header: ModalHeader) => set(() => ({ modalHeader: header })),
  setModalActions: (actions: ModalAction[]) => set(() => ({ modalActions: actions })),
  setScrollBehavior: (behavior: 'inside' | 'outside') => set(() => ({ scrollBehavior: behavior })),
  toggle: () => set(state => ({ toggleModel: !state.toggleModel })),
  closeAllModals: () =>
    set({
      toggleModel: false,
      modelActive: ModelControlEnum.CONFIRMATION,
      modelContent: '',
      scrollBehavior: 'outside',
      classNames: { className: 'grid', classNameContent: '' },
      width: '',
      data: null,
      modalHeader: {
        title: 'Confirmation',
        subtitle: '',
        showCloseButton: true,
        className: '',
      },
      modalActions: [],
      previousModalState: null,
    }),
  reset: () =>
    set({
      toggleModel: false,
      modelActive: ModelControlEnum.CONFIRMATION,
      modelContent: '',
      scrollBehavior: 'outside',
      classNames: { className: 'grid', classNameContent: '' },
      width: '',
      data: null,
      modalHeader: {
        title: 'Confirmation',
        subtitle: '',
        showCloseButton: true,
        className: '',
      },
      modalActions: [],
      previousModalState: null,
    }),
}))
